<!-- 询价记录列表 -->
<template>
	<div class="container">
		<div style="margin-top: 20px;" v-if="enquiryLoading">
			<el-skeleton :loading="enquiryLoading" animated :rows="10"></el-skeleton>
		</div>
		<div class="enquiry-card" v-for="(enquiry, index) in enquirys" :key="index">
			<!-- 顶部信息栏 -->
			<div class="card-header">
				<div class="header-info" style="align-items: center;">
					<span class="status-tag" v-if="enquiry.status=='pending'">
						{{ statusInfo[enquiry.status] }}
					</span>
					<span class="status-tag" v-if="enquiry.status=='approved'" style="background: #016AF8;color: #fff;">
						{{ statusInfo[enquiry.status] }}
					</span>
					<span class="status-tag" v-if="enquiry.status=='rejected'" style="background: #D9001B;color: #fff;">
						{{ statusInfo[enquiry.status] }}
					</span>
					<span class="status-tag" v-if="enquiry.status=='expired'" style="background: #f2f2f2;color: #999;">
						{{ statusInfo[enquiry.status] }}
					</span>
					<span class="status-tag" v-if="enquiry.status=='found'" style="background: #016AF8;color: #fff;">
						{{ statusInfo[enquiry.status] }}
					</span>
					<span class="enquiry-number">{{ $t('enquiryNumber') }}：{{ enquiry.id }}</span>
				</div>

				<span class="enquiry-type">{{ $t('urgencyLevel') }}：{{ urgencyStatus[enquiry.urgency] }}</span>
				<span class="enquiry-type">
					{{ $t('remainingTime') }}：{{ enquiry.remainingTitle.replace('day',$t('day')).replace('hours',$t('hours')) }}</span>
				<span class="apply-time">{{ $t('applicationTime') }}：{{ enquiry.createTime }}</span>
			</div>

			<!-- 询价详情 -->
			<div class="enquiry-detail">
				<div class="detail-item" style="justify-content: space-between;">
					<div>
						<span class="label">{{ $t('purchaseType') }}：</span>
						<span class="label">{{categoryInfo[enquiry.categoryId]}}</span>
					</div>
					<div>
						<span class="label-child">{{ $t('priceRange') }}：</span>
						<span class="label-child">
							<template v-if="enquiry.priceMin && enquiry.priceMax">
								{{currencySymbol}}{{ enquiry.priceMin }}-{{ enquiry.priceMax }}
							</template>
							<template v-else-if="enquiry.priceMin">
								{{currencySymbol}}{{ enquiry.priceMin }} {{$t('rise')}}
							</template>
							<template v-else-if="enquiry.priceMax">
								{{currencySymbol}}{{ enquiry.priceMax }} {{$t('within')}}
							</template>
							<template v-else>
								{{$t('negotiable')}}
							</template>
						</span>
					</div>
					<div>
						<span class="label-child">{{ $t('purchaseQuantity') }}：</span>
						<span class="label-child">{{ enquiry.quantity || $t('unrestricted') }}</span>
					</div>
				</div>
				<div class="detail-item" style="font-size: 14px;">
					<span class="label-email">{{ $t('contactEmail') }}：</span>
					<span class="value">{{ enquiry.email || userInfo.email}}</span>
				</div>
				<div class="detail-item description">
					<div class="value">{{ enquiry.description }}</div>
				</div>

				<!-- 图片列表 -->
				<div class="image-list">
					<div class="image-item" v-for="(image, imgIndex) in enquiry.images" :key="imgIndex">
						<img :src="image">
					</div>
				</div>

				<!-- 操作按钮 -->
				<div class="action-buttons">
					<button class="btn btn-secondary" @click="viewApprovalRecords">
						{{ $t('viewApprovalRecords') }}
					</button>
					<button class="btn btn-primary" @click="viewQuotes(enquiry)"
						v-if="enquiry.status=='approved'">{{ $t('viewQuotes') }}</button>
					<button class="btn btn-danger" @click="revoke(enquiry.id,index)">{{ $t('revoke') }}</button>
				</div>
			</div>
		</div>
		<div class="nodata" v-if="enquirys.length==0&&!enquiryLoading" style="margin-top: 200px;">
			<img src="/icon/common/nodata.png">
			<span>{{$t('noData')}}</span>
		</div>
		<div class="loading">
			<!-- 加载更多状态 -->
			<div v-if="loadingMore" class="loading-more" style="margin: 30px 0; text-align: center;">
				<i class="el-icon-loading"></i>
				<span>{{$t('dataLoading')}}</span>
			</div>

			<!-- 已加载全部数据 -->
			<div v-if="!hasMore&&enquirys.length>0" class="load-all"
				style="margin: 30px 0; text-align: center; color: #999;">
				{{$t('loadingFinish')}}
			</div>
		</div>
		<el-dialog :title="$t('viewQuotes')" :visible.sync="localVisible" width="1000px" top="5vh" center
			@close="localVisible=false">
			<div class="view-quotes">
				<!-- 报价列表 -->
				<div class="quote-item" v-for="(quote, index) in quotes" :key="index">
					<!-- 商家信息 -->
					<div class="quote-header">
						<div class="store-info">
							<div class="vip-tag-left">
								<img src="/icon/common/vip.svg" style="width: 15px;">
								VIP1
							</div>
							<span class="store-name">{{ quote.storeName }}</span>
						</div>
					</div>

					<!-- 商家名称 -->
					<div class="quote-description">
						{{ quote.goodsName }}
					</div>

					<!-- 产品图片列表 -->
					<div class="quote-image-list">
						<div class="quote-image-item">
							<img :src="quote.goodsImage">
						</div>
					</div>

					<!-- 价格和联系按钮 -->
					<div class="quote-footer">
						<div class="quote-price">
							<span>{{currencySymbol}}</span>
							<span style="margin-left: 3px;">{{ quote.quotePrice }}</span>
						</div>
						<el-button type="primary" class="contact-btn" plain
							@click="contactSupplier(quote)">{{ $t('contactHim') }}</el-button>
					</div>
				</div>
				<div class="nodata" v-if="quotes.length==0&&loadQuotes" style="margin: 100px 0;width: 950px;">
					<img src="/icon/common/nodata.png">
					<span>{{$t('noData')}}</span>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import storage from "@/utils/storage.js";
	import productApi from '@/api/product';
	import wantedApi from '@/api/wanted'
	export default {
		name: 'enquiryList',
		props: {
			searchKeyword: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				localVisible: false,
				enquiryLoading: true,
				params: {
					pageNumber: 1,
					pageSize: 10,
				},
				statusInfo: {}, //状态
				categoryInfo: {}, //商品列表
				enquirys: [], //询价列表
				userInfo: {}, //用户信息
				currencySymbol: '', //币种
				loadingMore: false, // 加载更多的状态
				hasMore: true, // 是否还有更多数据
				isMounted: false, // 组件是否已挂载
				quotes: [], // 报价列表	
				loadQuotes: false
			}
		},
		mounted() {
			// 组件挂载后添加滚动事件监听器
			this.isMounted = true;
			window.addEventListener('scroll', this.handleScroll);
			// 组件销毁时移除滚动事件监听器
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll);
			});
		},
		computed: {
			urgencyStatus() {
				return {
					"very_urgent": this.$t('veryUrgent'),
					"urgent": this.$t('urgent'),
					"normal": this.$t('normal')
				};
			}
		},
		methods: {
			//初始化
			init() {
				this.currencySymbol = storage.getCurrencySymbol();
				this.getGoodsCategory();
				this.getStatusList();
				this.getUserInfo();
				this.enquiryLoading = true;
				this.params.pageNumber = 1;
				this.enquirys = [];
				this.hasMore = true;
				this.loadingMore = false;
				this.getWantedList();
			},
			//获取登录用户信息
			getUserInfo() {
				this.userInfo = JSON.parse(storage.getUserInfo());
			},
			//获取商品分类
			async getGoodsCategory() {
				const res = await productApi.getGoodsCategory(0);
				res.result.map(item => {
					this.categoryInfo[item.id] = item.name;
				})
			},
			//获取状态列表
			async getStatusList() {
				const res = await wantedApi.getStatusList();
				res.result.map(item => {
					this.statusInfo[item.code] = item.description;
				})
			},
			//获取我的询价列表
			async getWantedList() {
				var params = {
					...this.params
				}
				if (this.searchKeyword) {
					params.description = this.searchKeyword;
				}
				const res = await wantedApi.getWantedList(params);
				const enquiryList = res.result.records;

				// 处理剩余时间显示
				enquiryList.map(item => {
					item.remainingTitle = `${item.remainingHours}hours`;
					if (item.remainingHours > 24) {
						var days = Math.floor(item.remainingHours / 24);
						item.remainingTitle = `${days}day ${item.remainingHours - days * 24}hours`
					}
				})
				this.enquiryLoading = false;
				// 检查是否是第一页加载
				if (this.params.pageNumber === 1) {
					// 第一页直接替换数据
					this.enquirys = enquiryList;
				} else {
					// 后续页追加数据
					this.enquirys = [...this.enquirys, ...enquiryList];
				}

				// 检查是否还有更多数据
				const total = res.result.total;
				if (this.enquirys.length >= total) {
					this.hasMore = false;
				}

				// 重置加载状态
				this.loadingMore = false;
			},
			//查看审批记录
			viewApprovalRecords() {
				this.$message.info('开发中...')
			},
			//查看报价
			async viewQuotes(enquiry) {
				this.loadQuotes = false;
				const res = await wantedApi.getQuotesList({
					pageNumber: 1,
					pageSize: 100
				}, enquiry.id);
				if (res.result.total > 0) {
					this.quotes = res.result.records;
				}
				this.loadQuotes = true;
				this.localVisible = true;
			},
			// 联系供应商
			contactSupplier(quote) {
				this.$message.info('联系商家: ' + quote.storeName);
			},
			//撤回
			revoke(id, index) {
				this.$confirm(this.$t('revokeEnquiry'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning'
				}).then(() => {
					this.confirmRevoke(id, index);
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
			//确认撤回
			async confirmRevoke(id, index) {
				const res = await wantedApi.deleteWanted(id);
				if (res.code == 200) {
					if (!res.result) {
						//只有待审核和已通过状态的求购才能取消
						this.$message.warning(this.$t('revokeContidion'))
					} else {
						this.$message.success(this.$t('revokeSuccess'))
						this.enquirys.splice(index, 1);
					}
				} else {
					this.$message.warning(this.$t('revokeFail'))
				}
			},
			// 加载更多数据
			loadMore() {
				if (this.loadingMore || !this.hasMore) {
					return;
				}
				this.loadingMore = true;
				this.params.pageNumber++;
				this.getWantedList();
			},
			// 处理滚动事件
			handleScroll() {
				if (!this.isMounted || this.loadingMore || !this.hasMore) {
					return;
				}

				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				const clientHeight = document.documentElement.clientHeight || window.innerHeight;
				// 当距离底部小于230px时，加载更多数据
				if (scrollHeight - scrollTop - clientHeight < 230) {
					this.loadMore();
				}
			},
		}
	}
</script>

<style scoped>
	.container {
		width: 1200px;
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	/* 询价卡片样式 */
	.enquiry-card {
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
		overflow: hidden;
	}

	/* 卡片头部 */
	.card-header {
		background-color: #f9f9f9;
		padding: 15px 20px;
		border-bottom: 1px solid #eee;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #999;
		font-size: 14px;
	}

	.status-tag {
		background-color: #ffeeba;
		color: #856404;
		padding: 4px 12px;
		border-radius: 4px;
		font-size: 14px;
		font-weight: bold;
	}

	.header-info {
		display: flex;
		gap: 20px;
	}

	/* 询价详情 */
	.enquiry-detail {
		padding: 20px;
	}

	.detail-item {
		margin-bottom: 10px;
		display: flex;
		align-items: center;
	}

	.detail-item .label {
		font-weight: bold;
		color: #333;
	}

	.detail-item .label-email {
		color: #999;
	}

	.detail-item .label-child {
		font-size: 14px;
		color: #999;
	}

	.detail-item .value {
		flex: 1;
		color: #666;
	}

	.detail-item.description {
		margin-bottom: 20px;
	}

	/* 图片列表 */
	.image-list {
		display: flex;
		gap: 10px;
		margin-bottom: 20px;
	}

	.image-item {
		width: 150px;
		height: 150px;
		border: 1px solid #ddd;
		border-radius: 4px;
		overflow: hidden;
	}

	.image-item img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	/* 操作按钮 */
	.action-buttons {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}

	.btn {
		padding: 8px 16px;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
		transition: background-color 0.3s;
	}

	.btn-primary {
		background-color: #016AF8;
		color: #fff;
	}

	.btn-primary:hover {
		background-color: #007bff;
	}

	.btn-secondary {
		background-color: #eb8604;
		color: #fff;
	}

	.btn-secondary:hover {
		background-color: #F59A23;
	}

	.btn-danger {
		background-color: #D9001B;
		color: #fff;
	}

	.btn-danger:hover {
		background-color: #f56c6c;
	}

	/* 报价列表样式 */
	.view-quotes {
		padding: 0;
		margin-top: -20px;
	}

	.quote-item {
		background-color: #f9f9f9;
		border-radius: 8px;
		padding: 10px;
		margin-bottom: 20px;
	}

	.quote-header {
		margin-bottom: 15px;
	}

	.store-info {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.vip-tag {
		background-color: #ffc107;
		color: #856404;
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 12px;
		font-weight: bold;
	}

	.store-name {
		font-weight: bold;
		color: #333;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 90%;
	}

	.quote-description {
		margin-bottom: 15px;
		color: #666;
		line-height: 1.5;
	}

	/* 报价图片列表样式 */
	.quote-image-list {
		display: flex;
		gap: 10px;
		margin-bottom: 15px;
	}

	.quote-image-item {
		width: 120px;
		height: 120px;
		border-radius: 4px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
	}

	.quote-image-item img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.quote-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.quote-price {
		font-size: 18px;
		font-weight: bold;
		color: #F59A23;
		padding-left: 10px;
	}

	.contact-btn {
		border: 1px solid #016AF8 !important;
		color: #fff;
		padding: 10px 30px;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	.contact-btn:hover {
		background-color: #016AF8;
	}
</style>